import React from 'react';
import PostCard from './PostCard';

export default function MasonryGrid({ items, onImageClick, onReport }) {
  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-retro-brown">
        <p className="text-2xl font-display uppercase tracking-wider">No posts found.</p>
        <p className="text-lg font-bold text-retro-brown/60 mt-2">Try exploring more categories.</p>
      </div>
    );
  }

  return (
    <div className="px-4 py-4 max-w-[2000px] mx-auto w-full">
      <div className="columns-2 md:columns-3 lg:columns-4 xl:columns-5 2xl:columns-6 gap-4 [column-fill:_balance] box-border mx-auto">
        {items.map((item) => (
          <PostCard 
            key={item.id} 
            item={item} 
            onImageClick={onImageClick} 
            onReport={onReport}
          />
        ))}
      </div>
    </div>
  );
}